<script setup lang="ts">
/**
 * App.vue - корневой компонент.
 * Определяет layout по route.meta.layout.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppLayout from '@/components/layout/AppLayout.vue'
import PublicLayout from '@/components/layout/PublicLayout.vue'
import NotificationContainer from '@/components/shared/NotificationContainer.vue'
import ReloadPrompt from '@/components/shared/ReloadPrompt.vue'

const route = useRoute()

const layout = computed(() => route.meta.layout as string | undefined)
</script>

<template>
  <!-- Публичная зона: header + content + footer -->
  <PublicLayout v-if="layout === 'public'" />

  <!-- Auth-страницы и прочие без layout (сами включают AuthLayout) -->
  <template v-else-if="layout === 'none' || !layout">
    <RouterView />
  </template>

  <!-- App layout: sidebar + header -->
  <AppLayout v-else-if="layout === 'app'" />

  <!-- Глобальные overlay-компоненты -->
  <NotificationContainer />
  <ReloadPrompt />
</template>
